(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
    document.querySelector('.announcement-bar-close-btn').addEventListener("click", (em) => {
    var _this = em.target;
    _this.closest('.announcement-bar-section').style.display = "none";

    const announcementSticky = document.querySelector('.shopify-section-announcement-sticky');
    const headerSticky = document.querySelector('.shopify-section-header-sticky');
    const compareModelBg = document.querySelector('.compare-model-bg-color');
    const headerSearchModal = document.querySelector('.header__search .search-modal');

    if (announcementSticky !== null && headerSticky !== null) {
      const announcementHeight = announcementSticky.offsetHeight;
      headerSticky.style.top = announcementHeight + 'px';

      if (compareModelBg !== null) {
        compareModelBg.style.top = 'var(--header-height)';
      }

      if (headerSearchModal !== null) {
        headerSearchModal.style.top = 'var(--header-height)';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-with-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  function revealOnScroll() {
    document.querySelectorAll(".banner-with-content").forEach((section) => {
      let sectionTop = section.getBoundingClientRect().top;
      let viewportHeight = window.innerHeight;

      if (sectionTop < viewportHeight * 0.8) {
        section.classList.add("is--animated");
      }
    });
  }
  window.addEventListener("scroll", revealOnScroll);
  revealOnScroll();
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    function revealOnScroll() {
      document.querySelectorAll(".banner__content-render-class").forEach((section) => {
        let sectionTop = section.getBoundingClientRect().top;
        let viewportHeight = window.innerHeight;

        if (sectionTop < viewportHeight * 0.8) {
          section.classList.add("active");
        }
      });
    }
    window.addEventListener("scroll", revealOnScroll);
    revealOnScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  function revealOnScroll() {
    document.querySelectorAll(".contact_grid").forEach((section) => {
      let sectionTop = section.getBoundingClientRect().top;
      let viewportHeight = window.innerHeight;

      if (sectionTop < viewportHeight * 0.8) {
        section.classList.add("is--animated");
      }
    });
  }
  window.addEventListener("scroll", revealOnScroll);
  revealOnScroll();
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["default-faq"] && !Shopify.designMode) return;
  try {
    
  
var acc = document.querySelectorAll('.default-faq-item .summary');
if(acc.length != 0){
  acc.forEach(function(item) {
    item.addEventListener("click", (em) => {
      var _this = em.target;
      if(_this.classList.contains('summary')){
        var _this = _this;
      }else{
        var _this = _this.closest('.summary');
      }

      _this.closest('.details').classList.toggle("is--open");
      var panel = _this.nextElementSibling;
       if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
  });
}

var show_more = document.querySelector('#show-more-faq');  
var show_less = document.querySelector('#read-less-faq');  
var hidden_Faqs = document.querySelectorAll(".hidden-faq");

if(show_more != null){
  show_more.addEventListener("click", (em) => {
    em.preventDefault();
    hidden_Faqs.forEach(el => el.style.display = "block");
    show_more.style.display = "none";
    show_less.style.display = "flex";
  });
} 

if(show_less != null){
  show_less.addEventListener("click", (em) => {
    em.preventDefault();
    hidden_Faqs.forEach(el => el.style.display = "none");
    show_more.style.display = "flex";
    show_less.style.display = "none";
  });
}    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
var acc = document.querySelectorAll('.faq-item .summary');
if(acc.length != 0){
  acc.forEach(function(item) {
    item.addEventListener("click", (em) => {
      var _this = em.target;
      if(_this.classList.contains('summary')){
        var _this = _this;
      }else{
        var _this = _this.closest('.summary');
      }

      _this.closest('.details').classList.toggle("is--open");
      var panel = _this.nextElementSibling;
       if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (document.querySelector('.shopify-section-announcement-sticky') != null) {
        const announcement_height = document.querySelector('.shopify-section-announcement-sticky').offsetHeight;
        document.querySelector('.shopify-section-header-sticky').style.top = announcement_height + 'px';
      }

      if (document.querySelector('.how-to-become-dealer') != null) {
        const ann_height = document.querySelector('.shopify-section-announcement-sticky').offsetHeight;
        const head_height = document.querySelector('.shopify-section-header-sticky').offsetHeight;
        document.querySelector('.how-to-become-dealer-container').style.top = ann_height + head_height + 10 + 'px';
      }

      var location_og = window.location.origin;
      if (location_og == 'https://eu.evercross.eu') {
        const scrollTop_default = window.pageYOffset || document.documentElement.scrollTop;

        const header_height = document.querySelector('.shopify-section-header-sticky').offsetHeight;
        if (document.querySelector('.reduce-top-space') != null) {
          document.querySelector('.reduce-top-space').style.marginTop = '-' + header_height + 'px';
        }

        if (scrollTop_default > 200) {
          if (document.querySelector('.shopify-section-header-sticky') != null) {
            document.querySelector('.shopify-section-header-sticky').classList.remove('remove-bg-color');
          }
        } else {
          if (document.querySelector('.shopify-section-header-sticky') != null) {
            document.querySelector('.shopify-section-header-sticky').classList.add('remove-bg-color');
          }
        }
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      var location_og = window.location.origin;
      if (location_og == 'https://eu.evercross.eu') {
        const header_height = document.querySelector('.shopify-section-header-sticky').offsetHeight;
        if (document.querySelector('.reduce-top-space') != null) {
          document.querySelector('.reduce-top-space').style.marginTop = '-' + header_height + '-px';
        }

        if (scrollTop > 200) {
          if (document.querySelector('.shopify-section-header-sticky') != null) {
            document.querySelector('.shopify-section-header-sticky').classList.remove('remove-bg-color');
          }
        } else {
          if (document.querySelector('.shopify-section-header-sticky') != null) {
            document.querySelector('.shopify-section-header-sticky').classList.add('remove-bg-color');
          }
        }
      }

      if (document.querySelector('.shopify-section-announcement-sticky') != null) {
        const announcement_height = document.querySelector('.shopify-section-announcement-sticky').offsetHeight;
        document.querySelector('.shopify-section-header-sticky').style.top = announcement_height + 'px';
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  var mega_tab = document.querySelectorAll('.megamenu-tab .megamenu-tab-btn');

  if (mega_tab.length != 0) {
    mega_tab.forEach(function (item) {
      item.addEventListener('click', (em) => {
        var _this = em.target;
        if (_this.classList.contains('megamenu-tab-btn')) {
          var _this = _this;
        } else {
          var _this = _this.closest('.megamenu-tab-btn');
        }
        var data_id = _this.getAttribute('data-id');

        var mega_tab_list = _this.closest('.megamenu-tab').querySelectorAll('.megamenu-tab-btn');
        mega_tab_list.forEach(function (content) {
          content.classList.remove('is--open');
        });
        _this.classList.add('is--open');

        var mega_content = _this
          .closest('.megamenu-content-list')
          .querySelector('.megamenu-content')
          .querySelectorAll('li');
        mega_content.forEach(function (content) {
          content.classList.remove('is--open');
        });
        _this
          .closest('.megamenu-content-list')
          .querySelector('.megamenu-content')
          .querySelector('li[data-id="' + data_id + '"]')
          .classList.add('is--open');
      });
    });
  }

  var main_title = document.querySelectorAll('.header__inline-menu header-menu details>summary.header__menu-item');

  if (main_title.length != 0) {
    main_title.forEach(function (item) {
      item.addEventListener('mouseenter', (em) => {
        var _this = em.target;
        if (_this.classList.contains('header__menu-item')) {
          var _this = _this;
        } else {
          var _this = _this.closest('.header__menu-item');
        }

        var mega_tab_list = _this.closest('.header__inline-menu').querySelectorAll('details>summary.header__menu-item');
        mega_tab_list.forEach(function (content) {
          content.closest('details').removeAttribute('open');
        });
        _this.closest('details').setAttribute('open', 'open');
      });
    });
  }

  var mouse_over = document.querySelector('sticky-header');

  if (mouse_over != null) {
    mouse_over.addEventListener('mouseleave', (em) => {
      var _this = em.target;
      if (_this.classList.contains('header-wrapper')) {
        var _this = _this;
      } else {
        var _this = _this.closest('.header-wrapper');
      }

      var mega_tab_list = _this.querySelectorAll('details>summary.header__menu-item');
      mega_tab_list.forEach(function (content) {
        content.closest('details').removeAttribute('open');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-block"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
    function revealOnScroll() {
      setTimeout(() => {
      document.querySelectorAll(".image-text-block-main").forEach((section) => {
        let sectionTop = section.getBoundingClientRect().top;
        let viewportHeight = window.innerHeight;

        if (sectionTop < viewportHeight * 0.8) {
          section.classList.add("active");
        }
      });
        }, 1500);
    }
    window.addEventListener("scroll", revealOnScroll);
    revealOnScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-connect"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  var trigger_click = document.querySelector('.social-connect-item:first-child .social-btn a.button');
   trigger_click.addEventListener("click", (em) => {
     em.preventDefault();
     document.querySelector('#Avada-FAQ_WidgetTrigger').dispatchEvent(new Event('click'));
   });
  
  function revealOnScroll() {
    document.querySelectorAll(".social-connect").forEach((section) => {
      let sectionTop = section.getBoundingClientRect().top;
      let viewportHeight = window.innerHeight;

      if (sectionTop < viewportHeight * 0.8) {
        section.classList.add("is--animated");
      }
    });
  }
  window.addEventListener("scroll", revealOnScroll);
  revealOnScroll();
});  

  } catch(e) { console.error(e); }
})();
})();
